import React, {FC, useState} from 'react'
import MonthsEndReportPage from './MonthsEndReportPage'
import AccountsMonthEndReportPage from './AccountsMonthEndReportPage'

type Tab = 'default-report' | 'accounts-report'

const MonthsEndReportTabsPage: FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('default-report')

  return (
    <>
      <div className='card mb-5' style={{boxShadow: 'none'}}>
        <div className='card-body pt-5 pb-0'>
          <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-0 fs-6'>
            <li className='nav-item'>
              <a
                className={`nav-link fw-semibold ${activeTab === 'default-report' ? 'active' : ''}`}
                href='#'
                onClick={(e) => {
                  e.preventDefault()
                  setActiveTab('default-report')
                }}
              >
                <i className='bi bi-hourglass-split me-2'></i>
                Default Month End Report
              </a>
            </li>
            <li className='nav-item'>
              <a
                className={`nav-link fw-semibold ${activeTab === 'accounts-report' ? 'active' : ''}`}
                href='#'
                onClick={(e) => {
                  e.preventDefault()
                  setActiveTab('accounts-report')
                }}
              >
                <i className='bi bi-calculator me-2'></i>
                Accounts Month End Report
              </a>
            </li>
          </ul>
        </div>
      </div>

      {activeTab === 'default-report' && <MonthsEndReportPage />}
      {activeTab === 'accounts-report' && (
        <div className='px-5'>
          <AccountsMonthEndReportPage />
        </div>
      )}
    </>
  )
}

export default MonthsEndReportTabsPage
